import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Icon, Button, Checkbox, Card, H3, H6, HTMLSelect } from '@blueprintjs/core';
import { CORPUS_TYPES } from '../constants';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CorpusHeader from '../common/CorpusHeader';

import './PredefinedCorpus.css';
//import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME, FRONT_USER_QUERY_LANG_COOKIE_NAME, FRONT_USER_ROLE_COOKIE_NAME } from '../../../auth/constants';
import { PREDEFINED_CORPORA_DIR } from '../../../constants';
//import { NavigateBeforeSharp } from '@material-ui/icons';


class PredefinedCorpus extends React.PureComponent {

  state = {
    selectedLang: Cookies.get(FRONT_USER_QUERY_LANG_COOKIE_NAME)? Cookies.get(FRONT_USER_QUERY_LANG_COOKIE_NAME):"fr",
    nbDocs:0,
    nbSents:0,
    nbToks:0,
    // the collections API separates the collection name and its attributes
    selectedCorpora: [],
    mergeSubCorpora: false,
    collocStatAvailable:{}, // records if a given predefined corpus (collName) has a colloc file
    vocStatAvailable:{} // records if a given predefined corpus (collName) has a voc file
  };


  // usefull to compute the new values for  nbToks, nbDocs, nbSents and to check vocStats and collocStats
  fetchCorpusFile = (collName,action) => {
    const endpoint = PREDEFINED_CORPORA_DIR+'/'+collName+'.json';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint,
      { credentials: 'omit'})
      .then((res) => {
        
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          this.setState({ vocStatAvailable:false});
          return;
        }
        res.json().then((corpus) => {

          const vocStatAvailable= this.state.vocStatAvailable;
          const collocStatAvailable = this.state.collocStatAvailable;
          if (action==="adding") {
            if (corpus.vocFile) {
              vocStatAvailable[collName]=1;
            }
            if (corpus.collocFile) {
              collocStatAvailable[collName]=1;
            }

            const nbToks=this.state.nbToks+corpus.nbToks;
            const nbDocs=this.state.nbDocs+corpus.nbDocs;
            const nbSents=this.state.nbSents+corpus.nbSents;
            this.setState({ vocStatAvailable, collocStatAvailable, nbToks, nbDocs, nbSents });
          } else {
            const nbToks=this.state.nbToks-corpus.nbToks;
            const nbDocs=this.state.nbDocs-corpus.nbDocs;
            const nbSents=this.state.nbSents-corpus.nbSents;
            this.setState({ vocStatAvailable, collocStatAvailable, nbToks, nbDocs, nbSents });
          }
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
  }


  handleLangChange = (e) => {
    e.preventDefault();
    Cookies.set(FRONT_USER_QUERY_LANG_COOKIE_NAME,e.target.value);
    this.setState({
      selectedLang: e.target.value,
      selectedCorpora: [],
      nbDocs:0,
      nbSents:0,
      nbToks:0,
      collocStatAvailable:{},
      vocStatAvailable:{} 
    });
  }

  addSelectedCorpus= (collName) => {
    const { selectedCorpora } = this.state;
    if (selectedCorpora.indexOf(collName) === -1) {
      selectedCorpora.push(collName);
      this.setState({ selectedCorpora:selectedCorpora});
      this.fetchCorpusFile(collName,"adding");
    }
  }
  removeSelectedCorpus= (collName) => {
    const { selectedCorpora } = this.state;
    const pos= selectedCorpora.indexOf(collName);
    if (pos !== -1) {
      selectedCorpora.splice(pos,1);
      this.setState({ selectedCorpora:selectedCorpora});
      this.fetchCorpusFile(collName,"removing");
    }
  }

  handleCorpusSelect = (e,collName,checkbox) => {
    const { selectedCorpora } = this.state;
    if (selectedCorpora.indexOf(collName) === -1) {
      this.addSelectedCorpus(collName);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else {
      this.removeSelectedCorpus(collName);
    }
   /*  if (checkbox) {
      if (e.target.checked) {
        this.addSelectedCorpus(collName);
        // console.log("add");
        e.stopPropagation();
      } else {
        // to remove a corpus from selection, only checkbox can be used
        this.removeSelectedCorpus(collName);
        //console.log("del");
        e.stopPropagation();
      }
    } else {
      this.addSelectedCorpus(collName);
      // console.log("add");
    } */
  }

  handleUnselectAll = () => {
    this.setState( {
      selectedCorpora:[],
      nbDocs:0,
      nbSents:0,
      nbToks:0,
      collocStatAvailable:{},
      vocStatAvailable:{} 
    });
  }

  handleSelectionReady = () => {
    const { selectedLang, selectedCorpora, mergeSubCorpora } = this.state;
    this.props.handleSelectPredefinedCorpus(selectedLang, selectedCorpora, mergeSubCorpora);
  }


  openVocPage=()=>{
    const predefinedCorpus = {
      type: CORPUS_TYPES.PREDEFINED,
      language: this.state.selectedLang,
      name: this.state.selectedCorpora,
    };
    this.props.onDescriptionQuery("__voc__",predefinedCorpus);
  };

  openCollocPage=()=>{
    const predefinedCorpus = {
      type: CORPUS_TYPES.PREDEFINED,
      language: this.state.selectedLang,
      name: this.state.selectedCorpora,
    };
    this.props.onDescriptionQuery("__colloc__",predefinedCorpus);
  };
  // type = __voc__ or __colloc__ or __meta__
  openMetaPage=()=>{
    const predefinedCorpus = {
      type: CORPUS_TYPES.PREDEFINED,
      language: this.state.selectedLang,
      name: this.state.selectedCorpora,
    };
    this.props.onDescriptionQuery("__meta__",predefinedCorpus);
  };


 
  render() {
    const {
      selectedLang,
      selectedCorpora
    } = this.state;

    const {      
      collections,
      allLangs,
    } = this.props;

    const selectedCorpusInfos = selectedCorpora.length === 1? collections[selectedLang][selectedCorpora[0]]:null;
    var tagsets;
    var genres;
    var yearMin=3000;
    var yearMax=0;
    var mixedTagset=false;

    if (selectedCorpora.length>1) {
      for (var corpusName of selectedCorpora) {
        var corpusInfos= collections[selectedLang][corpusName];
        if (tagsets) {
          const tagset=collections["collection"][corpusInfos.collection]['tagset'][selectedLang];
          const genre=corpusInfos.genre;
          if (tagsets.indexOf(tagset) === -1) {
            tagsets+=", "+tagset;
            mixedTagset=true;
          }
          if (genres.indexOf(genre) === -1) {
            genres+=", "+genre;
          }
        } else {
          tagsets=collections["collection"][corpusInfos.collection]['tagset'][selectedLang];
          genres=corpusInfos.genre;
        }
        if (corpusInfos.yearMin<yearMin) {
          yearMin=corpusInfos.yearMin;
        }
        if (corpusInfos.yearMax>yearMax) {
          yearMax=corpusInfos.yearMax;
        }
      }
    }

    const { t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    const collsInSelectedLang = (collections && selectedLang) ? collections[selectedLang]:[];
    const types=(collections && selectedLang) ? [...new Set(Object.keys(collsInSelectedLang).map( collName => collsInSelectedLang[collName].type ))].sort():[];
    const collectionsInSelectedLang={};

    if (collections && selectedLang) {
      const collNamesInSelectLang = Object.keys(collsInSelectedLang).filter( collName => collsInSelectedLang[collName].access!=="restricted" ||  Cookies.get(FRONT_USER_ROLE_COOKIE_NAME)==="user+" );
      // computation of total token size for a given languages
      var totNbTok=0;
      for (var collName of collNamesInSelectLang) {
        if (collsInSelectedLang[collName].tokenSize) {
          totNbTok+=collsInSelectedLang[collName].tokenSize
        }
      }
      
      for (const type of types) {
        collectionsInSelectedLang[type] = collNamesInSelectLang.filter( collName => collsInSelectedLang[collName].type === type ).sort().map(collName => (
          <Card
            onClick={(e) => this.handleCorpusSelect(e,collName,false)}
            interactive={true}
            key={collName}
            className="PredefinedCorpus__corpusCard"
          >
            <Checkbox
                name={"check"+collName}
                alignIndicator='right'
                onClick={(e) => this.handleCorpusSelect(e,collName,true)}
                checked={this.state.selectedCorpora.indexOf(collName) !== -1}
            /> 
            <div>
            
              <img
                className="PredefinedCorpus__collsThumb"
                src={collsInSelectedLang[collName].thumbnail}
                alt=""
              />
              <p className='collName'>{collections[selectedLang][collName]['name']}</p>

            </div>

          </Card>
        ));
      }
    }

    return (
      <>
        <CorpusHeader
          title={t('predefinedCorpus')}
          goToQuery={this.handleSelectionReady}
          ready={(selectedCorpora.length>0)}
        />

        <div className="PredefinedCorpus__core">

            <div className="PredefinedCorpus__langChoice">
              {t('language')}
              {' '}
              <HTMLSelect options={allLangs} value={this.state.selectedLang} onChange={this.handleLangChange} />
              <br/><br/>
              <p>{t('totNbTokColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(totNbTok)}</p>
             

            </div>

          <div className="PredefinedCorpus__corpusDetail">
            <Card className="PredefinedCorpus__innerCorpusDetail">
              {selectedCorpora.length===0 &&
                <p>{t('noCorpusHasBeenSelected')}</p>
              }

              {selectedCorpora.length===1 &&
                <>
                  <H3 className="margin-bottom-1-5rem">{selectedCorpora} <Button onClick={this.handleUnselectAll} icon="delete"></Button></H3>
                  <div className="PredefinedCorpus__corpusCaracs margin-bottom-1-5rem">
                    <div className="PredefinedCorpus__corpusCaracsChild">
                      <H6>{t('keyCaracteristics')}</H6>
                      <ul>
                        <li>{t('tagsetColon')} { collections["collection"][selectedCorpusInfos.collection]['tagset'][selectedLang] }</li>
                        <li>{t('genreColon')} { selectedCorpusInfos.genre }</li>
                        <li>{t('periodColon')} {selectedCorpusInfos.yearMin} - {selectedCorpusInfos.yearMax}</li>
                        {/* <li>{t('categoryColon')} {collections['collection'][selectedCorpusInfos.collection].category}</li> */}
                        {this.state.nbDocs &&
                            <li>{t('docNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(this.state.nbDocs)}</li>
                        }
                        {this.state.nbSents &&
                            <li>{t('sentNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(this.state.nbSents)}</li>
                        }
                        <li>{t('tokenNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(this.state.nbToks)}</li>
                      </ul>
                    </div>
                    <div className="PredefinedCorpus__corpusCaracsChild">
                      <img src={selectedCorpusInfos.thumbnail} className="PredefinedCorpus__corpusCaracImg" alt="" />
                    </div>
                  </div>

                  <H6>{t('description')}</H6>
                  <p dangerouslySetInnerHTML={{__html:selectedCorpusInfos.description}}></p>
                  <br/>
                  {this.state.vocStatAvailable &&
                    <Button name='__voc__' onClick={this.openVocPage}>{t('vocabulary')}</Button> 
                  }
                  &nbsp;
                  {this.state.collocStatAvailable &&
                    <Button value='__colloc__' onClick={this.openCollocPage}>{t('collocCollig')}</Button> 
                  }
                  &nbsp;
                  <Button value='__meta__' onClick={this.openMetaPage}>{t('metadata')}</Button> 

                </>
              }
              {selectedCorpora.length > 1 &&
                <>
                  <H3 className="margin-bottom-1-5rem">{selectedCorpora.join(", ")} <Button onClick={this.handleUnselectAll} icon="delete"></Button></H3>
                  <div className="PredefinedCorpus__corpusCaracs margin-bottom-1-5rem">
                    <div className="PredefinedCorpus__corpusCaracsChild">
                      <H6>{t('keyCaracteristics')}</H6>
                      <ul>
                        <li>{t('tagsetColon')} { tagsets }</li>
                        <li>{t('genreColon')} { genres }</li>
                        <li>{t('periodColon')} { yearMin.toString()+" - "+yearMax.toString()}</li>
                        <li>{t('docNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(this.state.nbDocs)}</li>
                        <li>{t('sentNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(this.state.nbSents)}</li>
                        <li>{t('tokenNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(this.state.nbToks)}</li>
                      </ul>
                    </div>
                  </div>
                  <p>
                    <Checkbox
                      label={t("mergeSubCorpora")}
                      name={"mergeSubCorpora"}
                      onClick={(e) => this.setState({mergeSubCorpora : ! this.state.mergeSubCorpora})}
                      checked={this.state.mergeSubCorpora}
                    /> 
                  </p> 
                  { mixedTagset && 
                      <p><Icon icon="warning-sign" /> {t('warnMixedTagset')}</p>
                  }

                </>
              }

            </Card>
          </div>
        </div>

          <div className="PredefinedCorpus__corpusSelection">
            
            { types.map( type => 
              <Accordion style={{width:"100%"}} defaultExpanded={true} key={type}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                <strong>{type}</strong>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="PredefinedCorpus__corpusList">
                      {collectionsInSelectedLang[type]}
                  </div>
                </AccordionDetails>
              </Accordion>
            )}
           
          </div>
      </>
    );
  }
}

PredefinedCorpus.propType = {
  handleSelectPredefinedCorpus: PropTypes.func,
  onDescriptionQuery: PropTypes.func,
  collections:PropTypes.object,
  allLangs:PropTypes.array
};

export default withTranslation()(PredefinedCorpus);
